import bb from "blingblingjs";
import { state } from "./state";
import * as images from '@shopify/theme-images';

export function createEventsManager() {
    const els = [];

    return {
        add(el, ev, fn) {
            els.push({ el, ev, fn });
            bb(el).on(ev, fn);
        },
        update() {
            // Unbind current bound events
            els.forEach(item => {
                bb(item.el).off(item.ev, item.fn);
            });

            // Remove no longer used nodes
            els.filter(item => {
                if (bb(item.el)) {
                    return item;
                }
            });
            // Rebind events
            els.forEach(item => {
                bb(item.el).on(item.ev, item.fn);
            });

            
        }
    };
}

export function getProductJson(product_handle) {

    return Promise.all([
        fetch(product_handle, {
            headers: {
                Accept: "application/json"
            }
        })
        .then(response => response.json()), 
        fetch(`${product_handle}?view=product-meta`)
        .then(response => response.json())])
        .then(function(values) {
            return {
                ...values[0], 
                meta : values[1] 
            };
        })
}



export function getStepTypes() {
    const types = [];

    const steps = bb(".js-el__configurator-step");

    steps.forEach((el, i) => {
        if (el.dataset.steptype) {
            const config = {};
            config.type = el.dataset.steptype;
            if (el.dataset.shopifyVariantOption)
                config.shopifyVariantOption = el.dataset.shopifyVariantOption;
            if (el.dataset.defaultValue)
                config.defaultValue = el.dataset.defaultValue;
            types.push(config);
        }
    });

    return types;
}

export function getValidOptionChoice() {}

/* -------------------- Get variant / id -------------------- */

export function getVariant(state, stepTypes) {
    const optionsToMatch = stepTypes
        .map((step, index) => {
            if (step.type == "option") {
                return {
                    key: step.shopifyVariantOption,
                    value: state.chosenOptions[index].value
                };
            }
            if (step.type == "splitOption") {
                return {
                    key: step.shopifyVariantOption,
                    value:
                        state.chosenOptions[index][0].value +
                        "/" +
                        state.chosenOptions[index][1].value
                };
            }

            return false;
        }).filter(item => item ? true : false)

    return state.product.product.variants.find(variant => {
        return optionsToMatch.every(option => {
            return variant[option.key].toLowerCase() == option.value.toLowerCase();
        });
    });
}


export function getVariantId(state, stepTypes) {
    return getVariant(state, stepTypes).id;
}

export function getProductFromUrl(){


    let productHandle = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    productHandle = productHandle.includes('?') ? productHandle.substring(0,productHandle.indexOf('?')) : productHandle;
    productHandle = productHandle.includes('#') ? productHandle.substring(0,productHandle.indexOf('#')) : productHandle;
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const variant = urlParams.get('v');

    let initialStepChoices;

    try {
        initialStepChoices = JSON.parse(urlParams.get('s'))
    } catch (error) {
        
    }

    initialStepChoices = initialStepChoices ? initialStepChoices : [];

    return {
        productHandle,
        variant,
        initialStepChoices
    }

}


export function createImageNameFromValue(value, prefix = '', suffix = '.png', trim = ''){

    let imageName = value.split(trim).join('');
    imageName = imageName.split('/').join('-');
    imageName = imageName.split(' ').join('-');
    imageName = imageName.split('ß').join('ss');
    imageName = imageName.split('ü').join('ue');
    imageName = imageName.split('ä').join('ae');
    imageName = prefix + imageName + suffix;

    return imageName;

}



export function getVariantImageUrlAsync(state, stepTypes, size ='1024x1024'){

    try {   

        let imageId = getVariant(state, stepTypes).image_id

        const image =  state.product.product.images.find(item =>item.id == imageId)

        return new Promise((resolve, reject) => {
            const img = document.createElement('img');
            img.addEventListener("load", () => resolve(img.src));
            img.addEventListener("error", err => reject(err));
            img.src = images.getSizedImageUrl(image.src, size);;
        });

    } catch {

    }
}

export function getVariantImageUrl(state, stepTypes, size ='1024x1024'){

    let imageId = getVariant(state, stepTypes).image_id

    const image =  state.product.product.images.find(item =>item.id == imageId)

    return images.getSizedImageUrl(image.src, size);
}



  
  